import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Step, StepContainer, SVGContainer } from '../components';
import { NAVIGATE } from '../wizard/actions';
import CheckedSvg from 'images/shared/checked.svg';
import GeneralToolSvg from 'images/shared/general-tool-logo.svg';

function Navigation({ pages, logo, dispatch, pagesInWizard }) {
  // seems state is broken in Safari inside an iframe
  // https://github.com/remix-run/react-router/discussions/10371
  const { state } = useLocation();

  let currentPageIndex = pages.indexOf(state?.page ?? pages[0]);
  if (currentPageIndex === -1) currentPageIndex = 0;

  const steps = pagesInWizard ? pagesInWizard : pages;
  const maxWidth = steps.length * 60;

  const ToolLogo = logo;

  return (
    <StepContainer maxWidth={maxWidth}>
      {Object.keys(steps).map((key, i) => {
        const active = currentPageIndex === i;
        const completed = i < currentPageIndex;
        const finish = i === steps.length - 1;
        const stepNumber = i + 1;

        if (finish) {
          return (
            <SVGContainer active={currentPageIndex >= i} key={i}>
              <ToolLogo />
            </SVGContainer>
          );
        }
        return (
          <Step active={active} completed={completed} onClick={() => {
            if(completed) {
              dispatch({
                type: NAVIGATE,
                delta: i - currentPageIndex,
              })
            }
          }} key={i}>
            {completed ? <CheckedSvg /> : stepNumber}
          </Step>
        );
      })}
    </StepContainer>
  );
}

const mapStateToProps = state => ({
  syncing: state.syncing,
  pages: state.pages,
  pagesInWizard: state.pagesInWizard,
  logo: state.logo,
});

Navigation.propTypes = {
  dispatch: PropTypes.func.isRequired,
  pages: PropTypes.arrayOf(PropTypes.string).isRequired,
  pagesInWizard: PropTypes.arrayOf(PropTypes.string),
  logo: PropTypes.func,
};

Navigation.defaultProps = {
  pagesInWizard: null,
  logo: GeneralToolSvg,
}

export default connect(mapStateToProps)(Navigation);
